import capitalize from "capitalize";
import phrases from "./phrases";
import { printPoints } from "./points";
const DEFAULT_TESTTESTING_WARNING_ORDER = ["checkstyle", "ktlint"];
export const DEFAULT_TESTTESTING_LIMIT = 10;
const DEFAULT_TEST_TESTING_OPTIONS = {
  successMessage: "Correctly identified all correct and incorrect examples."
};
export const testTestingTerminalOutput = (results, contents, options = DEFAULT_TEST_TESTING_OPTIONS) => {
  const outputOptions = { ...DEFAULT_TEST_TESTING_OPTIONS, ...options };
  const { points, showWarnings, treatAsErrors } = outputOptions;
  const testingCompleted = results.completedSteps.includes("testTesting");
  const testingSucceeded = results.completedSteps.includes("testTesting") && results.succeeded === true;
  const printedPoints = points ? `${printPoints(points)}

` : "";
  if (results.failedSteps.length > 0 || results.timeout) {
    const { failed } = results;
    if (results.timeout) {
      return {
        error: true,
        retry: true,
        output: `${printedPoints}Testing your submission timed out.
Check for unterminated loops. Or your algorithm may be too slow.

You may also try submitting your code again.`
      };
    } else if (failed.templateSubmission) {
      return { error: true, retry: true, output: `${printedPoints}Templating failed. Please report a bug.` };
    } else if (failed.checkstyle) {
      const output = failed.checkstyle?.errors.map(({ location: { source, line }, message }) => {
        return `${source === "" ? "Line " : `${source}:`}${line}: checkstyle error: ${message}`;
      }).join("\n") || "";
      const errorCount = Object.keys(failed.checkstyle?.errors || {}).length;
      return {
        error: true,
        retry: false,
        output: `${printedPoints}${output}
${errorCount} error${errorCount > 1 ? "s" : ""}`
      };
    } else if (failed.ktlint) {
      const output = failed.ktlint?.errors.map(({ location: { source, line }, detail }) => {
        return `${source === "" ? "Line " : `${source}:`}${line}: ktlint error: ${detail}`;
      }).join("\n") || "";
      const errorCount = Object.keys(failed.ktlint?.errors || {}).length;
      return {
        error: true,
        retry: false,
        output: `${printedPoints}${output}
${errorCount} error${errorCount > 1 ? "s" : ""}`
      };
    } else if (failed.compileSubmission) {
      const output = failed.compileSubmission.errors.map((error) => {
        const { location, message } = error;
        if (location) {
          const { source, line, column } = location;
          const originalLine = contents.split("\n")[line - 1];
          const firstErrorLine = message.split("\n").slice(0, 1).join();
          const restOfError = message.split("\n").slice(1).filter((line2) => {
            return !(source === "" && line2.trim().startsWith("location: class"));
          }).join("\n");
          return `${source === "" ? "Line " : `${source}:`}${line}: error: ${firstErrorLine}
${originalLine ? originalLine + "\n" + new Array(column >= 0 ? column : 0).join(" ") + "^" : ""}${restOfError ? "\n" + restOfError : ""}`;
        } else {
          return message;
        }
      }).join("\n") || "";
      const errorCount = Object.keys(failed.compileSubmission.errors).length;
      return {
        error: true,
        retry: false,
        output: `${printedPoints}${output}
${errorCount} error${errorCount > 1 ? "s" : ""}`
      };
    } else if (failed.checkInitialSubmission) {
      return {
        error: true,
        retry: false,
        output: `${printedPoints}Your submission had errors:
  ${failed.checkInitialSubmission}`
      };
    } else if (failed.checkCompiledSubmission || failed.checkExecutedSubmission && (!testingCompleted || testingSucceeded)) {
      return {
        error: true,
        retry: false,
        output: failed.checkExecutedSubmission?.includes("exceededLineLimit") ? `${printedPoints}Testing your submission timed out.
Check for unterminated loops. Or your algorithm may be too slow.` : `${printedPoints}Your submission had errors:
${failed.checkCompiledSubmission || failed.checkExecutedSubmission}`
      };
    } else if (!testingCompleted && !results.timeout) {
      return {
        error: true,
        retry: true,
        output: `${printedPoints}Invalid testing result. Please reload the page and try again.
If this happens repeatedly, please report a bug.`
      };
    }
  }
  if (!testingCompleted) {
    return {
      error: true,
      retry: true,
      output: `Didn't return a testing result. Please reload the page and try again.
If this happens repeatedly, please report a bug.`
    };
  }
  const { complete, completedSteps, failedLinting } = results;
  const warnings = {};
  if (failedLinting === true) {
    if (completedSteps.includes("checkstyle")) {
      const output = complete.checkstyle?.errors.map(({ location: { source, line }, message }) => {
        return `${source === "" ? "  Line " : `  ${source}:`}${line}: checkstyle error: ${message}`;
      }).join("\n") || "";
      const errorCount = Object.keys(complete.checkstyle?.errors || {}).length;
      warnings["checkstyle"] = `Your submission has checkstyle errors:
${output}
${errorCount} error${errorCount > 1 ? "s" : ""}`;
    } else if (completedSteps.includes("ktlint")) {
      const output = complete.ktlint?.errors.map(({ location: { source, line }, detail }) => {
        return `${source === "" ? "  Line " : `  ${source}:`}${line}: ktlint error: ${detail}`;
      }).join("\n") || "";
      const errorCount = Object.keys(complete.ktlint?.errors || {}).length;
      warnings["ktlint"] = `Your submission has ktlint errors:
${output}
${errorCount} error${errorCount > 1 ? "s" : ""}`;
    }
  }
  if (results.succeeded !== true) {
    const { testTesting } = results.complete;
    let message = "";
    if (testTesting.identifiedSolution !== true) {
      message = `Testing ${testTesting.total} examples, one of which is correct.
Your tests marked correct code as incorrect.`;
    } else {
      if (testTesting.incorrect + 1 === testTesting.total) {
        message = `Tested ${testTesting.total} examples, one of which is correct.
Your tests misidentified all incorrect examples.`;
      } else {
        message = `Tested ${testTesting.total} examples, one of which is correct.
Your tests misidentified ${testTesting.incorrect} example${testTesting.incorrect > 1 ? "s" : ""}.`;
      }
    }
    const notEmpty = results.complete.testTesting.output.find((o) => o.trim() !== "");
    const output = results.complete.testTesting.output.map((o) => o.trim()).join("---\n").trim();
    if (notEmpty) {
      message += `

Testing output:
${output}`;
    }
    warnings["testing"] = message;
  }
  const wellDone = capitalize(phrases[Math.floor(Math.random() * phrases.length)]);
  if (showWarnings) {
    for (const warning of Object.keys(warnings)) {
      if (!showWarnings.includes(warning)) {
        delete warnings[warning];
      }
    }
  }
  if (!points) {
    if (Object.keys(warnings).length === 0) {
      return {
        error: false,
        retry: false,
        output: `Correctly identified ${results.complete.testTesting.total} examples. Great job!`
      };
    } else if (warnings["testing"]) {
      return { error: false, retry: false, output: warnings["testing"] };
    } else {
      for (const which of DEFAULT_TESTTESTING_WARNING_ORDER) {
        if (warnings[which]) {
          if (treatAsErrors && treatAsErrors.includes(which)) {
            return {
              error: false,
              retry: false,
              output: `Your submission passed the tests, but was considered incorrect because of this error:

${warnings[which]}`
            };
          } else {
            return {
              error: false,
              retry: false,
              output: `Your submission passed the tests! ${wellDone}!
But we noticed a few things you could improve...

${warnings[which]}`
            };
          }
        }
      }
    }
  } else {
    if (Object.keys(warnings).length === 0) {
      return { error: false, retry: false, output: `${printedPoints}${outputOptions.successMessage} ${wellDone}!` };
    } else if (warnings["testing"]) {
      if (results.failed.checkExecutedSubmission) {
        return {
          error: false,
          retry: false,
          output: `Warning: These errors might prevent you from eventually earning full credit:
${results.failed.checkExecutedSubmission}

${warnings["testing"]}`
        };
      } else {
        return { error: false, retry: false, output: `${printedPoints}${warnings["testing"]}` };
      }
    } else {
      for (const which of DEFAULT_TESTTESTING_WARNING_ORDER) {
        if (warnings[which] && points.specification[which]) {
          return {
            error: false,
            retry: false,
            output: `${printedPoints}Your submission passed the tests, but you lost points for the following reason:

${warnings[which]}`
          };
        }
      }
      for (const which of DEFAULT_TESTTESTING_WARNING_ORDER) {
        if (warnings[which]) {
          return {
            error: false,
            retry: false,
            output: `${printedPoints}Your submission passed the tests! ${wellDone}!
But we noticed a few things you could improve...

${warnings[which]}`
          };
        }
      }
    }
  }
};
//# sourceMappingURL=testtestingoutput.js.map
